import '../../assets/css/login.css';
import React from 'react';
import Button from 'components/CustomButtons/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { FaSpinner } from 'react-icons/fa';
import { Redirect } from 'react-router-dom';
import LoginLogo from '../../assets/img/Login.png';
import { dominioLeanAspNetAPI } from '../../config/database';

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: '1vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function Login() {
  const classes = useStyles();
  const [redireciona, setRedireciona] = React.useState(false);
  const [snackPack, setSnackPack] = React.useState([]);
  const [messageInfo, setMessageInfo] = React.useState(undefined);
  const [messagemErro, setMessagemErro] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const profissionalStorage = localStorage.getItem('profissional');
    if (profissionalStorage) setRedireciona(true);
  }, []);

  React.useEffect(() => {
    if (snackPack.length && !messageInfo) {
      setSnackPack(prev => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      setOpen(false);
    }
  }, [snackPack, messageInfo, open, messagemErro]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
  };

  const handleSubmit = e => {
    e.preventDefault();

    setLoading(true);

    const usuario = document.getElementById('username').value;
    const senha = document.getElementById('password').value;

    const data = {
      usuario,
      senha,
    };

    dominioLeanAspNetAPI.post('/api/login', data).then(
      res => {
        localStorage.setItem('profissional', JSON.stringify(res.data));
        setRedireciona(true);
      },
      () => {
        const msg = 'Não foi possível fazer login com as credenciais informadas.';
        setLoading(false);
        setMessagemErro(msg);
        setOpen(true);
      }
    );
  };

  if (redireciona) return <Redirect from="/" to="/admin/mapaLeito" />;

  return (
    <Container component="main" maxWidth="xs">
      <Snackbar
        className="shackbar-interno"
        key={messageInfo ? messageInfo.key : undefined}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
        onExited={handleExited}
        message={messagemErro}
        action={
          <>
            <IconButton
              aria-label="close"
              color="inherit"
              className={classes.close}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </>
        }
      />
      <CssBaseline />
      <div className={classes.paper}>
        <img alt="logo" src={LoginLogo} />
        <div className="texto-imagem">MAPA DE LEITO</div>
        <div className="acessar">ACESSAR</div>
        <form className={classes.form} onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Usuário"
            name="username"
            autoComplete="email"
            autoFocus
            inputProps={{ style: { textTransform: 'uppercase' } }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Senha"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="info"
            className={classes.submit}
          >
            {loading ? <FaSpinner /> : <> Entrar </>}
          </Button>
        </form>
      </div>
    </Container>
  );
}
